/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import ym from 'react-yandex-metrika';
import styled from 'styled-components';
import { useMutation, useQuery } from '@apollo/client';
import Input from 'react-phone-number-input/input';
import { Field, Form, Formik } from 'formik';
import _ from 'lodash';
import { Button } from 'react-bootstrap';
import * as Yup from 'yup';
import { useAlert } from 'react-alert';
import loadable from '@loadable/component';

import {
  GQL_GET_ME,
  GQL_GET_PAGE,
  GQL_GET_SETTING,
  GQL_ME_UPDATE, GQL_PAY_REQUEST,
  GQL_PAY_STATUS,
  GQL_SEND_PROMO_REQUEST,
} from '../graphql/queries';
import {
  MODE_SINGLE,
  paymentProcess,
} from '../helpers/payment';
import { PROMO_PAGE } from '../helpers/main';
import ArtField from '../components/forms/ArtField';
import { useTranslation } from '../components/hooks/useTranslation';
import { RU_DOMAIN } from '../locales';

const ErrorScreen = loadable(() => import('./Error'));
const MetaTags = loadable(() => import('../components/MetaTags'));

const Presentation = () => {
  const { t } = useTranslation();
  const alert = useAlert();

  const [loading, setLoading] = useState(false);
  const [wasSending, setSending] = useState(false);
  const [dataPrice, setPrice] = useState({
    price: null,
    discount: null,
  });
  const [me, setMe] = useState({});

  const { data: dataMe } = useQuery(GQL_GET_ME, { fetchPolicy: 'cache-only' });

  useEffect(() => {
    if (_.get(dataMe, 'me._id')) {
      setMe(_.get(dataMe, 'me'));
    }
  }, [dataMe]);

  const [sendRequest] = useMutation(GQL_SEND_PROMO_REQUEST);
  const [payStatus] = useMutation(GQL_PAY_STATUS);
  const [payRequest] = useMutation(GQL_PAY_REQUEST);

  const { data: pageData, loading: loadingPage } = useQuery(GQL_GET_PAGE, {
    variables: { url: 'invitation' },
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    ym('hit', '/invitation');
  }, []);

  const update = (cache) => {
    const data = cache.readQuery({ query: GQL_GET_ME });
    data.me.signed_up = 'yes';
    cache.writeQuery({ query: GQL_GET_ME, data });
  };

  const redirect = () => {
    if (typeof window !== 'undefined') {
      // TODO make it dynamic from page
      window.location.href = 'https://t.me/+7r9KJWTzPOpiZmYy';
    }
  };

  const [updateMe] = useMutation(GQL_ME_UPDATE, { update });

  const { data: priceData } = useQuery(GQL_GET_SETTING, {
    fetchPolicy: 'network-only',
    variables: {
      code: 'promo_price',
    },
  });

  useEffect(() => {
    const priceSettings = _.get(priceData, 'setting.value', false);
    if (priceSettings) {
      const dp = priceSettings.split('/');
      if (_.get(dp, '[0]') && _.get(dp, '[1]')) {
        setPrice({
          price: dp[0],
          discount: +dp[1],
        });
      }
    }
    return () => {
      setPrice({
        price: null,
        discount: null,
      });
    };
  }, [priceData]);

  useEffect(() => {
    if (wasSending) {
      setTimeout(() => redirect(), 7000);
    }
  }, [wasSending]);

  let price = null;
  let buttonName = t('send', { ns: 'notification_modal' });
  if (dataPrice.price) {
    price = _.get(me, '_id') && dataPrice.discount
      ? dataPrice.price - (dataPrice.price * (dataPrice.discount / 100))
      : dataPrice.price;
    buttonName = t('send_price', { ns: 'notification_modal', price });
  }

  const page = _.get(pageData, 'page', {});
  const errorsPage = _.get(pageData, 'graphQLErrors', []);

  if (!_.isEmpty(errorsPage)) {
    return (<ErrorScreen errors={errorsPage} />);
  }
  if (_.isEmpty(page) && !loadingPage) {
    return (<ErrorScreen errors={[]} />);
  }
  const meta = {
    title: _.get(page, 'meta.title', ''),
    description: _.get(page, 'meta.description', ''),
    path: `${RU_DOMAIN}/invitation`,
    updated: _.get(page, 'updated_at', null),
    created: _.get(page, 'created_at', null),
  };

  const initialValues = {
    name: _.get(me, 'name', ''),
    email: _.get(me, 'email', ''),
    phone: _.get(me, 'phone', ''),
  };

  const _registerUser = async (values, setSubmitting, setErrors) => {
    let variables = { confirmed: 'yes' };
    alert.show(t('success_payed', { ns: 'notification_modal' }), { type: 'success' });
    if (_.get(me, '_id') && !me.phone) {
      // If user without phone
      await updateMe({ variables: { me: { phone: values.phone } } });
    }
    if (!_.get(me, '_id')) {
      // If user guest
      variables = {
        ...variables,
        email: values.email,
        phone: values.phone,
        name: values.name,
      };
    }
    const result = await sendRequest({ variables });
    const error = _.get(result, 'errors.[0]', {});
    if (_.isEmpty(error)) {
      setSending(true);
      alert.show(t('success', { ns: 'notification_modal' }), { type: 'success' });
      setLoading(false);
      setSending(true);
      return true;
    }
    setSubmitting(false);
    setErrors(error.extensions);
    setLoading(false);
    // switch off price to try fixed problems
    setPrice({ price: null, discount: null });
    alert.show(error.message, { type: 'danger' });
    return false;
  };

  const handleUpdate = async (values, { setSubmitting, setErrors }) => {
    if (!_.get(me, '_id')) {
      // If guest all fields required
      if (!values.phone) {
        alert.show(t('phone_required', { ns: 'notification_modal' }), { type: 'danger' });
        return false;
      }
      if (!values.email) {
        alert.show(t('email_required', { ns: 'notification_modal' }), { type: 'danger' });
        return false;
      }
      if (!values.name) {
        alert.show(t('name_required', { ns: 'notification_modal' }), { type: 'danger' });
        return false;
      }
    }
    if (_.get(me, '_id') && !me.phone && me.signed_up === 'no') {
      if (!values.phone) {
        alert.show(t('phone_required', { ns: 'notification_modal' }), { type: 'danger' });
        return false;
      }
    }
    if (_.get(me, '_id') && me.signed_up === 'yes') {
      // Don't do anything if user sign it yet
      return false;
    }
    try {
      if (price) {
        // 1) create payment and get token if whe have price settings
        const request = await payRequest({
          variables: {
            data: {
              name: _.get(values, 'name', null),
              email: _.get(values, 'email', null),
              phone: _.get(values, 'phone', null),
              model: PROMO_PAGE,
              mode: MODE_SINGLE,
            },
          },
        });
        const errors = _.get(request, 'errors.[0]', {});
        if (!_.isEmpty(errors)) {
          setSubmitting(false);
          setErrors(errors.extensions);
          setLoading(false);
          alert.show(errors.message, { type: 'danger' });
          return false;
        }
        const token = _.get(request, 'data.payRequest.token', null);
        if (token && typeof window !== 'undefined') {
          // 2) init payment and look payment status
          await paymentProcess({
            token,
            payStatus,
            onSuccess: () => _registerUser(values, setSubmitting, setErrors),
            onFiled: () => {
              alert.show(t('error', { ns: 'notification_modal' }), { type: 'danger' });
              setLoading(false);
            },
            onCancel: () => {
              setLoading(false);
            },
          });
          return true;
        }
        return true;
      }
      _registerUser(values, setSubmitting, setErrors);
      return true;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
      return false;
    }
  };

  const phoneRegExp = /^\+\d{7,16}$/;

  const nameRegex = /^[a-zA-Zа-яА-ЯйЙёЁ0-9 ]+$/;
  // Schema for guests
  let validationSchema = Yup.object().shape({
    // eslint-disable-next-line quotes
    name: Yup.string(t('only_text', { ns: 'validate' }))
      .min(5, t('minimum_length', { ns: 'validate', count: 5 }))
      .matches(nameRegex, t('text_num_space', { ns: 'validate' }))
      .required(t('required', { ns: 'validate' }))
      .nullable(),
    email: Yup
      .string(t('only_text', { ns: 'validate' }))
      .required(t('required', { ns: 'validate' }))
      .min(5, t('minimum_length', { ns: 'validate', count: 5 }))
      .max(70, t('maximum_length', { ns: 'validate', count: 70 }))
      .email(t('email_format', { ns: 'validate' }))
      .nullable(),
    phone: Yup.string()
      .matches(phoneRegExp, t('phone', { ns: 'validate' }))
      .required(t('required', { ns: 'validate' }))
      .nullable(),
  });

  if (_.get(me, '_id') && !me.phone) {
    // Schema for users without phone
    validationSchema = Yup.object().shape({
      phone: Yup.string()
        .matches(phoneRegExp, t('phone', { ns: 'validate' }))
        .required(t('required', { ns: 'validate' }))
        .nullable(),
    });
  } else if (_.get(me, '_id')) {
    // Schema for users with phone
    validationSchema = false;
  }

  const showPhone = !_.get(me, 'phone');

  const showEmail = !_.get(me, 'email');

  const showName = !_.get(me, 'name');

  const isWasSend = _.get(me, 'signed_up') === 'yes';

  const replaceContent = (str, find, replace) => {
    const parts = str.split(find);
    if (parts.length > 1) {
      return (
        <>
          <Description dangerouslySetInnerHTML={{ __html: parts[0] }} />
          {replace && replace}
          <Description dangerouslySetInnerHTML={{ __html: parts[1] }} />
        </>
      );
    }

    return (
      <>
        {replace && replace}
        <Description dangerouslySetInnerHTML={{ __html: str }} />
      </>
    );
  };

  return (
    <PresentationBox>
      {meta && <MetaTags {...meta} />}
      <Formik
        validationSchema={validationSchema}
        initialValues={initialValues}
        onSubmit={handleUpdate}
        enableReinitialize
      >
        {({
          isSubmitting, values, setFieldValue, errors,
        }) => (
          <Form>
            <Base>
              {_.get(page, 'cover.key') && (
                <ImageWrap>
                  <BackgroundImage src={`/files/${_.get(page, 'cover.key')}`} alt="main" />
                </ImageWrap>
              )}
              {wasSending && (
              <Area>
                <NameEnd>{t('thanks', { ns: 'notification_modal' })}</NameEnd>
                <Info>{t('redirect', { ns: 'notification_modal' })}</Info>
                <BtnArea>
                  <Button
                    type="submit"
                    onClick={redirect}
                    className="me-0 me-md-4 col-sm-12 col-lg-auto mb-4 mb-md-0"
                    size="lg"
                    variant="primary"
                  >
                    {t('go', { ns: 'notification_modal' })}
                  </Button>
                </BtnArea>
              </Area>
              )}
              {!wasSending && (
              <>
                <Name send={wasSending ? 1 : 0}>{_.get(page, 'name', '')}</Name>
                {_.get(page, 'avatar.key') && (
                <Image url={`/files/${_.get(page, 'avatar.key')}`} />
                )}
                <OffSet image={_.get(page, 'avatar.key', 0)}>
                  {page.description && replaceContent(
                    page.description,
                    '{form}', (
                      <>
                        <br />
                        {!isWasSend && (
                        <>
                          {showName && (
                          <>
                            <Label>{t('name', { ns: 'notification_modal' })}</Label>
                            <Field
                              name="name"
                              component={ArtField}
                              placeholder={t('placeholder_name', { ns: 'notification_modal' })}
                              className="form-control-lg w-100"
                              disabled={isSubmitting || loading}
                              value={_.get(values, 'name', '')}
                              onChange={(e) => setFieldValue('name', e.target.value)}
                            />
                          </>
                          )}
                          {showEmail && (
                          <>
                            <Label>{t('email', { ns: 'notification_modal' })}</Label>
                            <Field
                              name="email"
                              component={ArtField}
                              placeholder={t('placeholder_email', { ns: 'notification_modal' })}
                              className="form-control-lg w-100"
                              disabled={isSubmitting || loading}
                              value={_.get(values, 'email', '')}
                              onChange={(e) => setFieldValue('email', e.target.value)}
                            />
                          </>
                          )}
                          {showPhone && (
                          <div className="input-group">
                            <Label>{t('phone', { ns: 'notification_modal' })}</Label>
                            <Input
                              name="phone"
                              placeholder={t('placeholder', { ns: 'notification_modal' })}
                              className={`form-control-lg form-control w-100 ${
                                _.get(errors, 'phone') ? 'is-invalid' : ''
                              }`}
                              disabled={isSubmitting || loading}
                              value={
                                    _.get(values, 'phone', '') ? values.phone.replace('+8', '+7') : ''
                                  }
                              onChange={(value) => setFieldValue('phone', value)}
                            />
                            {_.get(errors, 'phone') && (
                            <div className="invalid-feedback d-block">
                              {t('required_phone', { ns: 'notification_modal' })}
                            </div>
                            )}
                          </div>
                          )}
                          <div className="row mt-5 w-100 mx-0">
                            {!_.get(me, '_id') && !!dataPrice.price && !!dataPrice.discount && (
                              <Discount>
                                {t('discount', { ns: 'notification_modal', discount: dataPrice.discount })}
                              </Discount>
                            )}
                            <Button
                              type="submit"
                              className="me-0 me-md-4 col-sm-12 col-lg-auto mb-4 mb-md-0"
                              size="lg"
                              variant="primary"
                              disabled={isSubmitting || loading}
                            >
                              {isSubmitting ? t('await', { ns: 'action' }) : buttonName}
                            </Button>
                          </div>
                        </>
                        )}
                      </>
                    ),
                  )}
                  {isWasSend && (
                  <>
                    <InfoSent>{t('was_sent', { ns: 'notification_modal' })}</InfoSent>
                    <BtnArea>
                      <Button
                        type="submit"
                        onClick={redirect}
                        className="me-0 me-md-4 col-sm-12 col-lg-auto mb-4 mb-md-0"
                        size="lg"
                        variant="primary"
                      >
                        {t('go', { ns: 'notification_modal' })}
                      </Button>
                    </BtnArea>
                  </>
                  )}
                </OffSet>
              </>
              )}
            </Base>
          </Form>
        )}
      </Formik>
    </PresentationBox>
  );
};

const Discount = styled.div`
  font-weight: 500;
  margin: 20px 0;
  padding: 20px;
  background-color: var(--art-main-gray);
  border-radius: 4px;
  color: var(--art-active);
`;

const InfoSent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  text-align: center;
  margin-top: 30px;
  font-size: 20px;
  margin-bottom: 40px;
  padding: 20px;
  border-radius: 10px;
  border: 1px solid rgba(116, 158, 250, 0.3);
  background-color: #c8d6f6;
`;

const BtnArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Area = styled.div`
  position: relative;
  max-width: 925px;
  min-height: 40vh;
  margin: 50vh auto 0;
  display: block;
  background-color: white;
  padding: 30px;
  z-index: 1;
`;

const OffSet = styled.div`
  position: relative;
  max-width: 925px;
  margin: ${({ image }) => (image ? '-125px auto 0' : '0 auto 0')};
  background-color: white;
  padding: ${({ image }) => (image ? '130px 30px 30px' : '30px')};
  z-index: 1;
  .flex-row.row {
    --bs-gutter-x: 0;
  }
  @media screen and (max-width: 900px) {
    margin: ${({ image }) => (image ? '-105px auto 0' : '0 auto 0')};
  }
  @media screen and (max-width: 500px) {
    margin: ${({ image }) => (image ? '-80px auto 0' : '0 auto 0')};
    padding: ${({ image }) => (image ? '90px 30px 30px' : '30px')};
  }
`;

const Info = styled.div`
  font-weight: 400;
  font-size: 24px;
  line-height: 120%;
  text-align: center;
  margin: 40px 0;
`;

const Base = styled.div`
  display: block;
  overflow: hidden;
  width: 100%;
`;

const ImageWrap = styled.div`
  z-index: -1;
  left: 0;
  top: 0;
  position: absolute;
  overflow-x: hidden;
`;

const BackgroundImage = styled.img`
  width: 100%;
  @media screen and (max-width: 1100px) {
    width: 140%;
    display: block;
    margin-left: -20%;
    margin-right: -20%;
  }
  @media screen and (max-width: 1000px) {
    width: 160%;
    display: block;
    margin-left: -30%;
    margin-right: -30%;
  }
`;

const Image = styled.div`
  background-image: url(${({ url }) => url});
  width: 200px;
  height: 200px;
  position: relative;
  z-index: 2;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  margin: 320px auto 20px;
  @media screen and (max-width: 1500px) {
    margin: 270px auto 20px;
  }
  @media screen and (max-width: 1300px) {
    margin: 230px auto 20px;
  }
  @media screen and (max-width: 1200px) {
    margin: 200px auto 20px;
  }
  @media screen and (max-width: 1150px) {
    margin: 150px auto 20px;
  }
  @media screen and (max-width: 1024px) {
    width: 180px;
    height: 180px;
  }
  @media screen and (max-width: 768px) {
    width: 160px;
    height: 160px;
  }
  @media screen and (max-width: 500px) {
    margin: 80px auto 20px;
    width: 120px;
    height: 120px;
  }
`;

const NameEnd = styled.div`
  font-weight: 700;
  font-size: 64px;
  line-height: 100%;
  text-align: center;
  margin-bottom: 50px;
  @media screen and (max-width: 768px) {
    font-size: 48px;
  }
  @media screen and (max-width: 500px) {
    font-size: 28px;
  }
  @media screen and (max-width: 400px) {
    margin-bottom: 30px;
  }
  @media screen and (max-width: 350px) {
    margin-bottom: 30px;
  }
`;

const Name = styled.div`
  font-weight: 700;
  font-size: 64px;
  line-height: 100%;
  max-width: 690px;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 50px;
  margin-top: 100px;
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: ${({ send }) => (send ? 120 : 95)}vh;
  }
  @media screen and (max-width: 1600px) {
    margin-top: 60px;
  }
  @media screen and (max-width: 768px) {
    font-size: 48px;
    margin-top: 15px;
  }
  @media screen and (max-width: 500px) {
    max-width: 400px;
    font-size: 28px;
  }
  @media screen and (max-width: 400px) {
    margin-top: 8px;
  }
`;

const Label = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 120%;
  margin-top: 40px;
`;

const Description = styled.div`
  font-weight: 400;
  font-size: 24px;
  line-height: 120%;
  margin-bottom: 20px;
  display: block;
  font-feature-settings: 'liga' off;
  ul {
    list-style-type: none;
    padding-left: 0;
    li {
      margin-bottom: 20px;
      &::before {
        content: '';
        position: relative;
        display: inline-block;
        width: 10px;
        height: 10px;
        background-color: var(--art-active);
        margin-right: 10px;
        margin-bottom: -3px;
        transform: translate(0, -50%) scaleY(1) rotate(45deg);
      }
    }
  }
  @media screen and (max-width: 500px) {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }
`;

const PresentationBox = styled.div`
  display: block;
  margin-bottom: 100px;
`;

export default Presentation;
